<template>
  <div class="account-manage app-region blank-t-v blank-l-h blank-r-h">
    <a-row type="flex" align="bottom" :gutter="[16, 16]" class="mg-normal">
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>账号</p>
          </a-col>
          <a-col>
            <a-input placeholder="请输入账号" v-model="table.search.account"></a-input>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>账号姓名</p>
          </a-col>
          <a-col>
            <a-input placeholder="请输入账号姓名" v-model="table.search.name"></a-input>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>账号状态</p>
          </a-col>
          <a-col>
            <a-select v-model="table.search.status" class="app-block" placeholder="请选择账号状态">
              <a-select-option :value="1">启用</a-select-option>
              <a-select-option :value="0">禁用</a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-space>
          <a-button type="primary" @click="searchTable">查询</a-button>
          <a-button @click="resetSearchTable">重置</a-button>
        </a-space>
      </a-col>
    </a-row>
    <a-row class="mg-normal">
      <a-col>
        <a-space>
          <a-button type="primary" @click="newAccount()">新增账号</a-button>
        </a-space>
      </a-col>
    </a-row>
    <a-table class="mg-normal" :loading="table.loading" :columns="table.columns" :data-source="table.data" rowKey="id" :pagination="table.page" @change="handlePageChange">
      <template slot="type" slot-scope="text, data">
        <a-tag color="blue" v-if="data.is_platform_role === 1">平台</a-tag>
        <a-tag color="green" v-else>社区</a-tag>
      </template>
      <template slot="state" slot-scope="text, data">
        <a-switch :checked="data.state === 1" :loading="data.stateLoading" @click="stateChange(data)"></a-switch>
      </template>
      <template slot="action" slot-scope="text, data">
        <a-space>
          <a-button type="link" @click="editAccount(data)">编辑</a-button>
          <a-button type="link" @click="deleteAccount(data)">删除</a-button>
        </a-space>
      </template>
    </a-table>
  </div>
</template>

<script>
  import AccountService from '@/io/account.js';

  export default {
    name: 'AccountManage',
    data() {
      let self = this;
      return {
        table: {
          loading: false,
          search: {
            account: null,
            name: null,
            status: []
          },
          page: {
            total: 0,
            current: 1,
            pageSize: 10,
            showQuickJumper: true,
            showSizeChanger: true,
            showTotal() {
              return `共${self.table.page.total}条`;
            }
          },
          data: [],
          columns: [
            {
              title: '账号',
              dataIndex: 'username'
            },
            {
              title: '账号姓名',
              dataIndex: 'name'
            },
            {
              title: '账号类型',
              scopedSlots: { customRender: 'type' }
            },
            {
              title: '角色',
              dataIndex: 'rolesText'
            },
            {
              title: '账号状态',
              scopedSlots: { customRender: 'state' }
            },
            {
              title: '操作',
              scopedSlots: { customRender: 'action' },
            }
          ]
        }
      }
    },
    activated() {
      this.initData();
    },
    methods: {
      newAccount() {
        this.table.page.current = 1;
        this.$router.push('/platform/account_manage/new');
      },
      editAccount(data) {
        this.$router.push(`/platform/account_manage/edit/${data.id}`);
      },
      deleteAccount(data) {
        let self = this;
        this.$confirm({
          title: '提示',
          content: '确认删除此账号？',
          onOk() {
            AccountService.del(data.id).then(res => {
              self.initData();
            }).catch(err => {});
          }
        });
      },
      stateChange(data) {
        let checked = data.state === 1;
        data.stateLoading = true;
        AccountService[checked ? 'disable' : 'enable'](data.id).then(res => {}).catch(err => {}).finally(() => {
          this.$afterFormSubmit(checked ? '关闭成功' : '开启成功');
          data.state = checked ? 0 : 1;
          data.stateLoading = false;
        });
      },
      searchTable() {
        this.table.page.current = 1;
        this.initData();
      },
      resetSearchTable() {
        this.table.search = {
          account: null,
          name: null,
          status: []
        };
        this.searchTable();
      },
      handlePageChange(page) {
        this.table.page.current = page.current;
        this.table.page.pageSize = page.pageSize;
        this.initData();
      },
      initData() {
        this.table.loading = true;
        return AccountService.listPage(
          this.table.search.account,
          this.table.search.name,
          this.table.search.status,
          this.table.page.current,
          this.table.page.pageSize
        ).then(res => {
          this.table.data = res.data.map(val => {
            val.stateLoading = false;
            val.rolesText = val.roles.map(val => val.title).join('，');
            return val;
          });
          this.table.page.total = res.meta.pagination.total;
        }).catch(err => {}).finally(() => {
          this.table.loading = false;
        });
      },
    },
  }
</script>

<style lang="less" scoped>

</style>